import { useCallback, useEffect, useRef } from "react"

import { Col, Flex, Row, Table, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import { connect, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"

import ButtonComponent from "../../../Components/Button"
import EmptyComponent from "../../../Components/Empty"
import { DashboardFiltersBlock } from "../../../Components/Filters/DashboardFiltersBlock/DashboardFiltersBlock"
import { RoutesPaths } from "../../../constants/user-routes"
import Icon from "../../../Icon"
import { getDates } from "../../../Utils/utils"
import { CardTotalPanel } from "../components/CardTotalPanel"
import { getDashboardProgressRowProps, usersBySourceTypeColumns } from "../components/Table/columns"
import { dashboardActions } from "./../redux/dashboard.slice"
import { getUsersBySourceData } from "./../redux/dashboard.thunks"

import "../styles.less"

const columns = usersBySourceTypeColumns.map((el) => ({
  ...el,
  width: "auto"
}))

const { Title } = Typography

export const UsersBySourcePage = ({ userInfo, dashboard, ...props }) => {
  const pageRef = useRef()
  const navigate = useNavigate()
  const { search } = useLocation()
  const isMobile = useSelector((state) => state.nav.isMobile)

  const { t } = useTranslation()
  const helpRef = useRef({ firstLoading: true })

  const { filters, usersBySourceData } = dashboard

  const handleChangeFilter = useCallback((newFilters) => {
    if (Array.isArray(newFilters.period)) {
      props.changeFilters({
        ...newFilters,
        period: { type: "custom", period: newFilters.period }
      })
    } else {
      props.changeFilters(newFilters)
    }
  }, [])

  useEffect(() => {
    document.title = "Dashboard - Chargeback"
    if (pageRef.current) pageRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [])

  useEffect(() => {
    if (filters?.period) {
      const period_query = getDates(filters.period)
      props.getUsersBySourceData({
        chartType: "users_by_source",
        ...period_query
      })

      if (helpRef.current.firstLoading) helpRef.current.firstLoading = false
    }
  }, [filters?.period])

  const goBack = () => {
    navigate(RoutesPaths.dashboard.root)
  }

  return (
    <Row ref={pageRef} gutter={[32, 32]} className={cls("dashboard-page")}>
      <Col span={24} style={{ padding: 0 }}>
        <ButtonComponent
          type={"text"}
          onClick={goBack}
          icon={<Icon type={"chevron_left_small"} />}
          style={{ marginLeft: !isMobile ? "-12px" : "-26px" }}
        >
          {t("Back to Overview")}
        </ButtonComponent>
      </Col>

      <Col span={24}>
        <Flex justify="space-between">
          <div>
            <Title level={4} style={{ marginBottom: 24 }}>
              {t("Users by Source")}
            </Title>
            <CardTotalPanel
              count={usersBySourceData?.total_count}
              showVolume={false}
              style={{ margin: 0 }}
            />
          </div>

          <DashboardFiltersBlock
            handleChangeFilter={handleChangeFilter}
            filters={filters}
            onlyPeriod={true}
          />
        </Flex>
      </Col>

      <Col span={24}>
        <Table
          className={"chart-table"}
          dataSource={usersBySourceData?.result}
          columns={columns}
          onRow={getDashboardProgressRowProps}
          pagination={false}
          rowKey="label"
          tableLayout="fixed"
          showHeader={!!usersBySourceData?.result?.length}
          locale={{
            emptyText: <EmptyComponent type="no_data_available" style={{ minHeight: 450 }} />
          }}
        />
      </Col>
    </Row>
  )
}

const mapStateToProps = (state) => ({
  userInfo: state.auth.userInfo,
  dashboard: state.dashboard
})

const mapDispatchToProps = (dispatch) => ({
  getUsersBySourceData: (params) => dispatch(getUsersBySourceData(params)),
  changeFilters: (filters) =>
    dispatch(dashboardActions.dashboardSetProp({ key: "filters", value: filters }))
})

export default connect(mapStateToProps, mapDispatchToProps)(UsersBySourcePage)
